import React from "react";
import {NumericFormat} from "react-number-format";

const ListStat = ({data}) => {
    return (
        <>
            {data &&
                <div className="m-1 ml-2">
                    Showing {data.start}-{data.end}, from <strong><NumericFormat displayType={'text'} thousandSeparator={true} value={data.total}/></strong> records
                </div>
            }
        </>
    )
}

export default ListStat
